<template>
    <div class="page">
        <br/>
        <div class="title">注销申请</div>
        <br/>
        <div class="small-title">注意！ 注意 ！注意 ！</div>
        <div class="small-title">请认真填注销的资料！</div>
        <div class="small-title">卡板注销后您将永久无法使用此卡，卡内的余额我们将于1-15个工作日内给您原路退回，注销后卡内现有的流量套餐将立即清空，继续提交申请将默认您同意本声明，</div>
        <div class="view-box">
            <div class="text">
                注销卡号<span></span>
                <van-field v-model="dataForm.iccid"  clear-trigger="always" class="ph-t" clearable placeholder="请输入要注销的卡号" />
            </div>
        </div>  
        <div class="view-box">
            <div class="text">注销原因</div>
            <van-field
                v-model="dataForm.problemContent"
                rows="2"
                autosize
                type="textarea"
                class="textarea"
                maxlength="300"
                placeholder="请填写注销原因"
                show-word-limit
            />
        </div>

        <div class="view-box">
            <div class="text">
                您的姓名<span></span>
                <van-field v-model="dataForm.name"  clear-trigger="always" class="ph-t" clearable placeholder="请输入姓名" />
            </div>
        </div>  
        <div class="view-box">
            <div class="text">
                联系方式<span></span>
                <van-field v-model="dataForm.userPhone" type="number" clear-trigger="always" class="ph-t" clearable placeholder="请输入联系手机号" maxlength="11" />
            </div>
        </div>  
        

        <div class="view-box">
            <div class="text">剪卡照片<span>(必填)</span></div>
            <div class="text1">请上传剪卡后的照片，有卡号的那一面。照片不符 不予退款</div>
            <van-uploader multiple v-model="flieList" :max-count="1"/>
        </div>
       
        <div class="tick">
            <van-checkbox v-model="checked" shape="square" icon-size="16px"/>
            <div class="tick-name">同意商家客服获取描述、图片和手机号码，以便联系您解决问题</div>
        </div>
        <div class="footer-btn">
            <van-button type="primary" @click="sumbit">提交注销</van-button>
        </div>
    </div>
</template>
<script>
import { Toast} from 'vant';
import { Dialog } from 'vant'
import { wxRequest } from '@/api/user'
export default{
    data(){
        return{
            dataForm:{
                type:1,
                problemContent:'',
                iccid:'',
                userPhone:''
            },
            flieList:[],
            checked:true,
        }
    },
    created(){
    },
    methods: {
        customer(){
            window.location.href='http://kefu.szxxtx.com/s/135302p4tv';
        },
        sumbit() {
            if(!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.dataForm.userPhone))){
                Toast.fail('请填写正确的手机号');
                return;
            }
            if(!this.dataForm.iccid){
                Toast.fail('请填写卡号');
                return;
            }
            if(!this.dataForm.problemContent){
                Toast.fail('请填写注销原因');
                return;
            }
            let fd = new FormData();
            Object.keys(this.dataForm).forEach((key) => {
                fd.append(key, this.dataForm[key])
            });
            if(this.flieList.length > 0){
                fd.append("title",  this.flieList[0].file)
            }else{
                Toast.fail('请上传剪卡图片！');
                return;
            }
           
            wxRequest("/userProblem/add/img", fd, "post").then(res => {
                if(res.data.code === '200'){
                    Toast.fail('注销提交成功！');
                return;
                }else{
                    Dialog.alert({ message: res.data.message });
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
div{
    display: flex;
    flex-grow: 0;
    flex-basis: auto;
    align-items: stretch;
    flex-direction: column;
}
.page{
	background: #f7f8fa;
    .title{
        font-size: 36px;
        text-align: center; 
        font-weight: 800;
        color: #0095FF;
        padding: 15px
    }
    .small-title{
        text-align: center; 
        font-size: 20px;
        font-weight: 400;
        font-weight: bold;
        color: #06121e;
        padding: 5px 15px 15px;
        line-height: 22px;
    }
    .view-box{
        padding: 10px 15px;
        background: #fff;
        margin-top: 10px;
        .text{
            font-size: 16px;
            font-weight: 800;
            color: #06121e;
            align-items: center;
            flex-direction: row;
            span{
                font-size: 16px;
                font-weight: 400;
                color: #999;
                margin: 0 5px;
            }
        }
        .text1{
            font-size: 14px;
            font-weight: 400;
            color: #bdc4ce;
            margin-top: 10px;
        }
        .textarea{
            min-height:150px;
            ::v-deep .van-field__body{
                height:94%;
                .van-field__control{
                    height:100% !important;
                }
            }
        }
        .van-uploader{
            margin: 6px;
        }
        .ph-t{
            padding-left: 10px;
            flex: 1 1 0%;
        }
    }
    .tick{
        flex-direction: row;
        padding: 15px;
        margin-bottom: 15px;
        .tick-name{
            font-size: 14px;
            font-weight: 400;
            color: #8c9198;
            line-height: 24px;
        }
        .van-checkbox{
            width:26px;
            margin-top:4px;
        }
    }
    .footer-btn{
        flex-direction: row;
        align-items: center;
        margin-bottom: 20px;
        .van-button{
            width:100%;
        }
    }
}
</style>
